(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.calloutPhotoIconCarousel = {
    attach: function (context, settings) {
      console.log('calloutPhotoIconCarousel behavior attached');

      // Wait for Swiper to be available
      if (typeof Swiper === 'undefined') {
        console.error('Swiper not loaded');
        return;
      }

      // Initialize all callout photo icon carousels on the page
      const carousels = once('callout-photo-icon-carousel', '.callout-photo-icon-carousel', context);
      console.log('Found carousels:', carousels.length);

      carousels.forEach(function(carousel) {
        console.log('Initializing carousel:', carousel);
        const autoplay = carousel.dataset.autoplay === 'true';

        // Get the outer container (parent of the swiper)
        const outerContainer = carousel.closest('.callout-photo-icon-carousel__container');

        // Check for required elements - navigation buttons are now in the outer container
        const nextEl = outerContainer ? outerContainer.querySelector('.callout-photo-icon-carousel__button--next') : null;
        const prevEl = outerContainer ? outerContainer.querySelector('.callout-photo-icon-carousel__button--prev') : null;
        const paginationEl = carousel.querySelector('.callout-photo-icon-carousel__pagination');

        console.log('Navigation elements:', { nextEl, prevEl, paginationEl });

        // Initialize Swiper
        const swiper = new Swiper(carousel, {
          // Slides per view - show 1 full slide at a time
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          watchOverflow: true,
          allowTouchMove: true, // Allow touch/swipe
          speed: 500, // Smooth transition speed

          // Navigation arrows
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },

          // Pagination
          pagination: {
            el: paginationEl,
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          },

          // Autoplay (if enabled)
          autoplay: autoplay ? {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          } : false,

          // Accessibility
          a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
          },

          // Keyboard control
          keyboard: {
            enabled: true,
          },

          // Loop mode - disabled to show/hide arrows appropriately on first/last slide
          loop: false,

          // Events
          on: {
            init: function () {
              console.log('Swiper initialized');
            },
          },
        });

        console.log('Swiper instance created:', swiper);
      });
    }
  };
})(Drupal, once);